import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { api, imageUrl } from "../lib/api";

export default function News() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/articles")
      .then((r) => setArticles(r.data))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="news-page" className="pt-32 pb-24">
      <section className="px-6 md:px-10 pb-12 max-w-7xl mx-auto">
        <p className="font-overline text-xs text-[#DE9E48] mb-4">— News &amp; Press</p>
        <h1 className="font-display text-6xl md:text-8xl tracking-tighter leading-none">
          Latest <span className="italic text-[#DE9E48]">Articles.</span>
        </h1>
        <p className="font-body text-stone-400 mt-6 max-w-2xl text-lg">
          Stay updated with the most recent news about Encore Theatre and Gallery.
        </p>
      </section>

      <section className="px-6 md:px-10 py-12 max-w-7xl mx-auto">
        {renderArticles(loading, articles)}
      </section>
    </div>
  );
}

function renderArticles(loading, articles) {
  if (loading) {
    return <p className="text-stone-400 font-overline text-sm">Loading…</p>;
  }
  if (articles.length === 0) {
    return (
      <p data-testid="news-empty" className="text-stone-400 font-overline text-sm">
        No articles yet.
      </p>
    );
  }
  return (
    <div className="grid md:grid-cols-2 gap-8">
      {articles.map((a, i) => (
        <a
          key={a.id}
          href={a.link || "#"}
          target={a.link && a.link !== "#" ? "_blank" : "_self"}
          rel="noopener noreferrer"
          data-testid={`news-article-${i}`}
          className="group block border border-white/10 hover:border-[#DE9E48]/50 bg-stone-900/50 transition-colors"
        >
          {a.image_url && (
            <div className="aspect-[16/9] overflow-hidden bg-stone-950">
              <img
                src={imageUrl(a.image_url)}
                alt={a.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
            </div>
          )}
          <div className="p-8">
            <h3 className="font-display text-3xl leading-tight group-hover:text-[#DE9E48] transition-colors">
              {a.title}
            </h3>
            <p className="font-body text-stone-400 mt-3 leading-relaxed">{a.excerpt}</p>
            <p className="font-overline text-xs text-[#DE9E48] mt-6 flex items-center gap-2">
              Read Article <ArrowRight size={12} />
            </p>
          </div>
        </a>
      ))}
    </div>
  );
}
